import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'
import { DigitizationComponent } from './digitization.component'

export const digitizationRoutes: Routes = [
  {
    path: 'digitization',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'DIGITIZATION',
        redirectTo: '/',
      },
    },
    children: [{ path: '', component: DigitizationComponent }],
  },
]
